export interface ConexaoPec {
  id: number;
  ativo: boolean;
  host: string | null;
  porta: number;
  database: string | null;
  usuario: string | null;
  sslMode: string;
  schemaName: string;
  temSenha: boolean;
  ultimoTesteEm: string | null;
  ultimoTesteOk: boolean | null;
  ultimoTesteMsg: string | null;
  atualizadoEm: string;
}

export interface ResultadoTestePec {
  ok: boolean;
  compativel?: boolean;
  mensagem: string;
  tabelasLegiveis?: number;
  faltando?: string[];
  semPermissao?: string[];
}

export interface SituacaoPec {
  ativo: boolean;
  disponivel: boolean;
}

/**
 * Dados do paciente vindos do PEC.
 *
 * Note a ausência de telefone: por regra do KAVI, o contato é sempre digitado
 * pelo operador da unidade. Ver `backend/src/pec/pec.connector.ts`.
 */
export interface PacientePec {
  cns: string | null;
  cpf: string | null;
  nome: string | null;
  dataNascimento: string | null;
  nomeMae: string | null;
  email: string | null;
  endereco: string | null;
  origem: 'CAD_INDIVIDUAL' | 'CIDADAO';
}

export const ROTULOS_ORIGEM: Record<PacientePec['origem'], string> = {
  CAD_INDIVIDUAL: 'Cadastro Individual',
  CIDADAO: 'Cadastro do cidadão',
};
